<template>
  <div class="col-xs-10 col-sm-10 grid_div" id="grid_right_div">
    <!--<div id="flushBtn"></div>-->
    <div id="contentDiv">
      <div class="head_title">
        <div class="head_title_font">学习培训管理&gt;</div>
      </div>

      <div class="body_content">
        <div class="classList_div">
          <table class="table table-striped table-bordered table_trainingManage">
            <thead>
            <tr>
              <th width="15%">姓名
                <button type="button" class="btn btn_option"
                        style="padding: 2px 10px;margin-left: 10px"
                        @click="option_flag = 'add';modalShow()">新建
                </button>
              </th>
              <th width="25%">地点</th>
              <th width="35%">内容</th>
              <th width="15%">时间</th>
              <th width="10%">操作</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(trainingManageOne, index) in trainingManageList" :key="index">
              <td width="15%">{{trainingManageOne.teacherName}}</td>
              <td width="25%">{{trainingManageOne.addr}}</td>
              <td width="35%">{{trainingManageOne.content}}</td>
              <td width="15%">{{trainingManageOne.startDate}}—{{trainingManageOne.endDate}}</td>
              <td width="10%">
                <div v-if="trainingManageOne.creatorId == userId">
                  <div class="edit_pic" data-toggle="modal" data-target="#myModal"
                       @click="update_trainingPeople_id=trainingManageOne.id;option_flag='update';editTrainingPeople()">
                  </div>
                  <div class="delete_pic" @click="deleteTrainingPeople(trainingManageOne.id)"></div>
                </div>
                <div v-else>
                  <div></div>
                  <div></div>
                </div>
              </td>
            </tr>
            </tbody>
          </table>

          <!--新增或修改-->
          <div class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
            <div class="modal-dialog">
              <div class="modal-content modal-work-content">
                <div class="modal-header">
                  <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
                  <h4 class="modal-title" id="myModalLabel">
                    {{option_flag=="add"?'新增':'修改'}}
                  </h4>
                </div>
                <div class="modal-body modal_work_trainingManage">
                  <div>
                    <input type="text" class="form-control modelInput" v-validate="'required|maxL:30'" data-vv-scope="trainingPeople" data-vv-as="姓名" name="name" placeholder="输入姓名" v-model="searchTeacherName" @keyup="loadQueryInputDataWhenAdd()" autocomplete="off">
                    <span class="spanRed">*</span>
                    <span class="validateTip">{{ errors.first('trainingPeople.name') }}</span>
                    <!--<span class="validateTip">{{  errors.clear('trainingPeople.name')}}</span>-->

                    <div id="teachers_div">
                      <option v-for="(queryData, index) in queryInputDataArr" :key="index" :value="queryData.userName"
                              @click="putTeacherData(index)">{{queryData.userName}}-{{queryData.mobile}}</option>
                    </div>
                    <input type="text" class="form-control modelInput" v-validate="'required|maxL:80'" data-vv-scope="trainingPeople" data-vv-as="地点" name="place" placeholder="输入地点" v-model="trainingManageInfo.addr" autocomplete="off">
                    <span class="spanRed">*</span>
                    <span class="validateTip">{{ errors.first('trainingPeople.place') }}</span>

                    <input type="text" class="form-control modelInput" v-validate="'required|maxL:100'" data-vv-scope="trainingPeople" data-vv-as="内容" name="content" placeholder="输入内容" v-model="trainingManageInfo.content" autocomplete="off">
                    <span class="spanRed">*</span>
                    <span class="validateTip">{{ errors.first('trainingPeople.content') }}</span>

                    <input type="text" class="form-control modelInput" v-validate="'required|date_format:yyyy-MM-dd|beforeDate:结束时间'" ref="beforeDateTarget" data-vv-scope="trainingPeople" data-vv-as="开始时间"  name="startDate"  placeholder="输入开始时间" id="startDate" v-model="trainingManageInfo.startDate" readonly>
                    <span class="spanRed">*</span>
                    <span class="validateTip">{{ errors.first('trainingPeople.startDate') }}</span>


                    <input type="text" class="form-control modelInput" v-validate="'required|date_format:yyyy-MM-dd|afterDate:开始时间'" ref="afterDateTarget" data-vv-scope="trainingPeople" data-vv-as="结束时间" name="endDate" placeholder="输入结束时间" id="endDate" v-model="trainingManageInfo.endDate" readonly>
                    <span class="spanRed">*</span>
                    <span class="validateTip">{{ errors.first('trainingPeople.endDate') }}</span>
                  </div>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-default" @click="addTrainingPeople()">确定</button>
                  <button type="button" class="btn btn-default" data-dismiss="modal">取消</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {schoolAxios} from '../main';
  import {getContentSize} from './mainView';
  import dictionaryData from '../json/dictionary';
  import {Validator} from 'vee-validate';

  export default {
    name: "trainingManage",
    data() {
      return {
        clazzId: this.$store.state.clazzId,
        publishStatus: this.$store.state.publishStatus,
        classStatus: this.$store.state.classStatus,
        userId:this.$store.state.userId,
        //教务领导
        leaderUserCode: this.$store.state.leaderUserCode,
        userCode: this.$store.state.userCode,

        //今日日期
        timeDate: '',
        //培训人员集合
        trainingManageList:[],

        option_flag: '',

        //培训人员对象
        trainingManageInfo:{
          id:'',
          teacherId:'',
          teacherName:'',
          addr:'',
          content:'',
          startDate:'',
          endDate:''
        },

        //修改培训人员ID
        update_trainingPeople_id: '',

        //教师查询
        queryInputDataArr:[],

        searchTeacherName:'',
      }
    },
    filters: {

    },
    created: function () {

    },
    mounted: function () {
      let this_ = this;
      this.$nextTick(function () {
        getContentSize();

        this_.initTrainingManageListData();//日期

        //绑定加载关闭模态框时的事件
        this_.closeModal();

        this_.dateDefault();

        this_.loadValidator();
      });
    },
    methods: {
      loadValidator(){
        let this_ = this;
        //日期之前验证
        const isBeforeDate = {
          validate: function (value, args) {
            let date1 = new Date(value);
            let obj = this_.$refs.afterDateTarget.value;
            if(obj){
              let data2 = new Date(obj);
              return date1.getTime() <= data2.getTime();
            }else {
              return true;
            }
          }
        }
        Validator.extend('beforeDate', isBeforeDate);
        //日期之后验证
        const isAfterDate = {
          validate: function (value, args) {
            let date1 = new Date(value);
            let obj = this_.$refs.beforeDateTarget.value;
            if(obj){
              let data2 = new Date(obj);
              return date1.getTime() >= data2.getTime();
            }else {
              return true;
            }
          }
        }
        Validator.extend('afterDate', isAfterDate);
      },
      /**
       * 加载培训人员列表
       */
      initTrainingManageListData(){
        let this_ = this;
        if(this_.userCode.indexOf(this_.leaderUserCode) != -1){
          schoolAxios({
            method: 'get',
            url: 'trainingLearn/findListForLedear',
            params: {
            }
          }).then(function (resp) {
            if(resp.data.success){
              // console.info(this_.userId);
              this_.trainingManageList = resp.data.list;
            }
          });
        }else {
          schoolAxios({
            method: 'get',
            url: 'trainingLearn/findList',
            params: {
            }
          }).then(function (resp) {
            if(resp.data.success){
              // console.info(this_.userId);
              this_.trainingManageList = resp.data.list;
            }
          });
        }
      },

      /**
       * 联想查询教师信息-add
       */
      loadQueryInputDataWhenAdd(){
        let this_ = this;
        this_.trainingManageInfo.teacherId = "";
        this_.trainingManageInfo.teacherName = "";
        if(this_.searchTeacherName != ""){
          //后台查询数据赋值
          schoolAxios({
            method: 'get',
            url: 'user/queryUserSchoolByUserName',
            params: {
              'userName': this_.searchTeacherName
            }
          }).then(function (resp) {
            let data = resp.data;
            if(data.success){
              this_.queryInputDataArr = data.list;
              $("#teachers_div").show();
            }
          });
        }else{
          this_.queryInputDataArr= [];
        }
      },

      /**
       * 新增老师时获得数据
       */
      putTeacherData(index){
        let this_ = this;
        if(index >= 0){
          let data = this_.queryInputDataArr[index];

          this_.trainingManageInfo.teacherId = data.id;
          this_.trainingManageInfo.teacherName = data.userName;

          this_.searchTeacherName = data.userName;
          $("#teachers_div").hide();
        }
      },
      /**
       * 添加培训人员
       */
      addTrainingPeople(){
        let this_ = this;
        this_.$validator.validateAll('trainingPeople').then(result => {
          if (result) {
            let method = "";
            let url = "";
            if (this_.option_flag == "add") {
              method = "post";
              url = "trainingLearn/add";
            } else {
              method = "put";
              url = "trainingLearn/edit";
            }
            if(this_.trainingManageInfo.teacherName == ""){
              this_.trainingManageInfo.teacherName = this_.searchTeacherName;
            }
            schoolAxios({
              method: method,
              url: url,
              data: {
                id:this_.trainingManageInfo.id,
                teacherId:this_.trainingManageInfo.teacherId,
                teacherName: this_.trainingManageInfo.teacherName,
                addr: this_.trainingManageInfo.addr,
                content: this_.trainingManageInfo.content,
                startDate: this_.trainingManageInfo.startDate,
                endDate: this_.trainingManageInfo.endDate,
              }
            }).then(function (resp) {
              let data = resp.data;
              if (data.success) {
                $("#myModal").modal("hide");
                this_.initTrainingManageListData();
                "保存成功".showMessage();
                // this.$validator.clean();
              } else {
                "请输入系统中存在的教师".showMessage();
              }
            });
          }
        });
      },


      modalShow(){
        let this_=this;
        // this_.errors.clear('trainingPeople');
        $("#myModal").modal("show");
      },

      /**
       * 关闭模态框监听
       */
      closeModal() {
        let this_ = this;
        $("#myModal").on('hide.bs.modal', function () {
          this_.searchTeacherName = '';
          this_.queryInputDataArr = [];
          this_.trainingManageInfo = {
            id:'',
            teacherId:'',
            teacherName:'',
            addr:'',
            content:'',
            startDate:'',
            endDate:''
          }
          setTimeout(function () {
            this_.errors.clear('trainingPeople');
          });

        });
      },

      editTrainingPeople(){
        let this_ = this;
        schoolAxios({
          method: 'get',
          url: 'trainingLearn/load/'+this_.update_trainingPeople_id,
          params: {}
        }).then(function (resp) {
          let data = resp.data;
          if(data.success){
            this_.trainingManageInfo = data.data;
            this_.searchTeacherName = data.data.teacherName;
            $("#myModal").modal("show");
          }
        });
      },


      /**
       * 删除培训人员
       */
      deleteTrainingPeople(id){
        let this_ = this;
        "确定删除".showConfirm(function () {
          schoolAxios({
            method: 'delete',
            url: 'trainingLearn/delete/'+id,
            params: {}
          }).then(function (resp) {
            let data = resp.data;
            if(data.success){
              "删除成功".showMessage();
              this_.initTrainingManageListData();
            }else{
              "删除失败".showMessage();
            }
          })
        })
      },

      /**
       * 初始化日期选择框
       */
      dateDefault(){
        let this_ = this;
        let date, nowDate;
        date = new Date();
        nowDate = date.getFullYear() + "-";
        nowDate += (date.getMonth() + 1) + "-";
        nowDate += date.getDate() + " ";
        this_.timeDate = nowDate;
        $('#startDate').datetimepicker({
          minView: "month",//选择日期后，不会再跳转去选择时分秒
          language: 'zh-CN',
          format: 'yyyy-mm-dd',
          //startDate: this_.timeDate,
          weekStart: 0,
          todayBtn: true,
          clearBtn: true,
          autoclose: true,//选择一个日期后是否立即关闭此选择框
          todayHighlight: true,//高亮当前日期
          startView: 2,// 日期时间选择器打开之后首先显示的视图，默认值为：2，0:hour,1:day,2:mouth,3:year,4:decade
          forceParse: 0,
          showMeridian: 1,
        }).on('hide', function (ev) {
          let value = $("#startDate").val();
          this_.trainingManageInfo.startDate = value;

          ev.preventDefault();
          ev.stopPropagation();
        });
        $('#endDate').datetimepicker({
          minView: "month",
          language: 'zh-CN',
          format: 'yyyy-mm-dd',
          //startDate: this_.timeDate,
          weekStart: 0,
          todayBtn: true,
          clearBtn: true,
          autoclose: true,
          todayHighlight: true,
          startView: 2,
          forceParse: 0,
          showMeridian: 1,
        }).on('hide', function (ev) {
          let value = $("#endDate").val();
          this_.trainingManageInfo.endDate = value;
          ev.preventDefault();
          ev.stopPropagation();
        });
      },
    }
  }
</script>

<style scoped>
  @import '../assets/css/plugins.css';
  @import "../assets/css/publicStyle.css";
  @import "../assets/css/trainingManage.css";
</style>



// WEBPACK FOOTER //
// src/components/trainingManage.vue